module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/delegation/svg-icon/svg-icon-component.css
// module id = ./src/app/modules/delegation/svg-icon/svg-icon-component.css
// module chunks = main